import { render, staticRenderFns } from "./createBus.vue?vue&type=template&id=1e71dbf4&scoped=true&"
import script from "./createBus.vue?vue&type=script&lang=js&"
export * from "./createBus.vue?vue&type=script&lang=js&"
import style0 from "./createBus.vue?vue&type=style&index=0&id=1e71dbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e71dbf4",
  null
  
)

export default component.exports